import type { FeedbackKind } from "@/shared/api";
import { FEEDBACK_KINDS } from "../../../kinds";
import styles from "../FeedbackDialog.module.css";

interface KindPickerProps {
  value: FeedbackKind;
  disabled: boolean;
  onChange: (kind: FeedbackKind) => void;
}

/**
 * The first question: which of the three things is this?
 *
 * Real radio inputs inside a `fieldset`, not styled buttons. Arrow keys move
 * between them, the group announces itself as a group, and the whole set is one
 * tab stop - none of which comes free with a row of `<button>`s, and all of
 * which somebody will rely on.
 *
 * The label is visible rather than a placeholder, and each option carries a line
 * saying which to pick. Somebody choosing wrongly is not a problem - the issue
 * gets relabeled in a second - but somebody hesitating and giving up is.
 */
export function KindPickerView({ value, disabled, onChange }: KindPickerProps) {
  return (
    <fieldset className={styles.kinds} disabled={disabled}>
      <legend className={styles.legend}>What would you like to tell us?</legend>

      {FEEDBACK_KINDS.map((option) => (
        <label
          key={option.kind}
          className={option.kind === value ? styles.kindChosen : styles.kind}
        >
          <input
            type="radio"
            name="feedback-kind"
            value={option.kind}
            checked={option.kind === value}
            onChange={() => onChange(option.kind)}
          />
          <span className={styles.kindText}>
            <span className={styles.kindLabel}>{option.label}</span>
            <span className={styles.kindHint}>{option.hint}</span>
          </span>
        </label>
      ))}
    </fieldset>
  );
}
